import React from 'react'
import { func, object } from 'prop-types'
import Panel from 'react-bootstrap/lib/Panel'
import ListGroup from 'react-bootstrap/lib/ListGroup'

import SideListItem from './side-list-item'

const Side  = ({ onForm, list }) => {
  if (!list) {
    return null
  }

  const header = (
    <div className="row">
      <div className="col-xs-9">Fees Presets</div>
      <div className="col-xs-3 text-right"><button type="button" onClick={onForm} className="btn-icon btn-inline">+</button></div>
    </div>
  )
  return (
    <Panel header={header}>
      <ListGroup fill>
        {list.map((item, k) => (
          <SideListItem key={k} item={item} />
        ))}
      </ListGroup>
    </Panel>
  )
}

Side.propTypes = {
  list: object,
  onForm: func,
}

export default Side



// WEBPACK FOOTER //
// ./src/containers/FeesPresets/side.js